module.exports = __webpack_public_path__ + "static/media/box.0c1499b2.svg";